import React from "react";
import { EqupRoundLoaderWithoutOverlay } from "../Components/Common/Loader/RoundLoader";
import NavigationWrapper from "../Layouts/NavigationWrapper";
import { BUILD_ID } from "../Utils/buildInfo";

const RetryFallback = ({ retry }) => {
  return (
    <React.Fragment>
      <NavigationWrapper show={["public", "private"]} runQueries={false} />
      <div style={{ textAlign: "center", padding: "24px" }}>
        <EqupRoundLoaderWithoutOverlay />
        <div style={{ marginTop: "8px", opacity: 0.7 }}>Build: {BUILD_ID}</div>
        <div style={{ marginTop: "16px" }}>
          <button type="button" onClick={retry}>
            Try Again
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ marginLeft: "12px" }}
          >
            Reload App
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RetryFallback;
